import React from "react";
import { Trash2 } from "lucide-react";
import { STATUS_OPTIONS } from "../../hooks/useLeads";

const Item = ({ label, children }) => (
  <div>
    <dt className="font-display text-[10px] uppercase tracking-[0.3em] text-[#0A192F]/60">
      {label}
    </dt>
    <dd className="mt-1 text-[#0A192F]/85">{children}</dd>
  </div>
);

const StatusButtons = ({ active, onChange }) => (
  <div className="mt-6">
    <div className="font-display text-[10px] uppercase tracking-[0.3em] text-[#0A192F]/60 mb-2">
      Status
    </div>
    <div className="flex gap-2 flex-wrap">
      {STATUS_OPTIONS.map((s) => (
        <button
          key={s.v}
          onClick={() => onChange(s.v)}
          data-testid={`admin-lead-status-${s.v}`}
          className={`px-3 py-1.5 text-[11px] font-display uppercase tracking-wider border transition-colors ${
            active === s.v
              ? "border-[#0A192F] bg-[#0A192F] text-white"
              : "border-gray-300 text-[#0A192F] hover:border-[#D4AF37]"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  </div>
);

export const LeadDetail = ({ lead, onStatusChange, onDelete }) => {
  if (!lead) {
    return (
      <div className="lg:col-span-3 bg-white border border-gray-200">
        <div className="p-10 text-center text-[#0A192F]/50 text-sm">
          Select a lead to view details
        </div>
      </div>
    );
  }

  return (
    <article data-testid="admin-lead-detail" className="lg:col-span-3 bg-white border border-gray-200 p-8">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h2 className="font-display font-black text-2xl text-[#0A192F]">{lead.name}</h2>
          {lead.company && (
            <div className="text-sm text-[#0A192F]/60 mt-1">{lead.company}</div>
          )}
        </div>
        <button
          onClick={() => onDelete(lead.id)}
          data-testid="admin-lead-delete"
          className="text-red-600 hover:text-red-800 text-xs font-display uppercase tracking-wider inline-flex items-center gap-1"
        >
          <Trash2 size={12} /> Delete
        </button>
      </div>

      <dl className="mt-6 grid sm:grid-cols-2 gap-4 text-sm">
        <Item label="Email">
          <a
            href={`mailto:${lead.email}`}
            className="text-[#0A192F] underline hover:text-[#D4AF37]"
          >
            {lead.email}
          </a>
        </Item>
        <Item label="Phone">
          {lead.phone ? (
            <a href={`tel:${lead.phone}`} className="text-[#0A192F] hover:text-[#D4AF37]">
              {lead.phone}
            </a>
          ) : (
            "-"
          )}
        </Item>
        <Item label="Project Type">{lead.project_type || "-"}</Item>
        <Item label="Received">{new Date(lead.created_at).toLocaleString()}</Item>
        <Item label="Project Date">{lead.project_date || "-"}</Item>
        <Item label="Project Location">{lead.project_location || "-"}</Item>
      </dl>

      <div className="mt-6">
        <div className="font-display text-[10px] uppercase tracking-[0.3em] text-[#0A192F]/60">
          Message
        </div>
        <div className="mt-2 text-sm text-[#0A192F]/85 whitespace-pre-wrap bg-[#F0F4F8] p-4 border border-gray-200">
          {lead.message}
        </div>
      </div>

      <StatusButtons
        active={lead.status || "new"}
        onChange={(s) => onStatusChange(lead.id, s)}
      />

      <div className="mt-8 flex gap-3">
        <a
          href={`mailto:${lead.email}?subject=Re: Your CM Lindley Inquiry`}
          className="inline-flex items-center gap-2 bg-[#0A192F] text-white px-5 py-3 font-display text-xs uppercase tracking-[0.25em] font-bold hover:bg-[#D4AF37] hover:text-[#0A192F] transition-colors"
        >
          Reply by Email
        </a>
      </div>
    </article>
  );
};

export default LeadDetail;
